/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CriticalNotificationSeverityEnum,
    CriticalNotificationSeverityEnumFromJSON,
    CriticalNotificationSeverityEnumFromJSONTyped,
    CriticalNotificationSeverityEnumToJSON,
} from './CriticalNotificationSeverityEnum';

/**
 * 
 * @export
 * @interface CreateCriticalNotificationDto
 */
export interface CreateCriticalNotificationDto {
    /**
     * 
     * @type {CriticalNotificationSeverityEnum}
     * @memberof CreateCriticalNotificationDto
     */
    severity: CriticalNotificationSeverityEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCriticalNotificationDto
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateCriticalNotificationDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateCriticalNotificationDto
     */
    activeTo: Date;
}

export function CreateCriticalNotificationDtoFromJSON(json: any): CreateCriticalNotificationDto {
    return CreateCriticalNotificationDtoFromJSONTyped(json, false);
}

export function CreateCriticalNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriticalNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'severity': CriticalNotificationSeverityEnumFromJSON(json['severity']),
        'text': json['text'],
        'activeFrom': (new Date(json['activeFrom'])),
        'activeTo': (new Date(json['activeTo'])),
    };
}

export function CreateCriticalNotificationDtoToJSON(value?: CreateCriticalNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'severity': CriticalNotificationSeverityEnumToJSON(value.severity),
        'text': value.text,
        'activeFrom': (value.activeFrom.toISOString()),
        'activeTo': (value.activeTo.toISOString()),
    };
}

